import { BookSection as OriginalComponent } from './BookSection';

export const BookSection = OriginalComponent;



// WEBPACK FOOTER //
// ./app/components/BookSection/index.js